import TargetSystemTable from "./TargetSystemTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const TargetSystem = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_configureagreement_targetsystem_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) ? <TargetSystemTable /> : ""}</>
  );
};

export default TargetSystem;
